import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';
import { decodeHTML } from 'entities/decode';

export type BlogCardData = Pick<Blog, 'id' | 'name' | 'slug'> & {
  image: { url: string } | null;
  excerpt: string;
};

const EXCERPT_LENGTH = 220;

/** Text-only summary, not an HTML sanitizer. Always render the result as React text. */
export function getBlogExcerpt(content: string | null | undefined): string {
  const stripped = (content ?? '')
    .replace(/<!--[\s\S]*?-->/g, ' ')
    .replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1\s*>/gi, ' ')
    .replace(
      /<(?:\/(?:p|div|h[1-6]|li|ul|ol|blockquote|section|article|tr|td)|br|hr)\b[^>]*>/gi,
      ' ',
    )
    .replace(/<[^>]*>/g, '');
  const text = decodeHTML(stripped).replace(/\s+/g, ' ').trim();

  const characters = Array.from(text);
  if (characters.length <= EXCERPT_LENGTH) return text;
  const truncated = characters.slice(0, EXCERPT_LENGTH - 1).join('');
  const lastSpace = truncated.lastIndexOf(' ');
  const end = lastSpace >= EXCERPT_LENGTH * 0.7 ? lastSpace : truncated.length;
  return `${truncated.slice(0, end).trimEnd()}…`;
}

/** Drop article bodies and unrelated API fields before crossing the RSC boundary. */
export function toBlogCardData(blog: Blog): BlogCardData {
  return {
    id: blog.id,
    name: blog.name,
    slug: blog.slug,
    image: blog.image?.url ? { url: blog.image.url } : null,
    excerpt: getBlogExcerpt(blog.content),
  };
}
